import React from 'react';
import styles from './Beacon.module.css';

interface BeaconProps {
  x: number; // percentage from left of constellation
  y: number; // percentage from top of constellation
  visible: boolean;
}

function Beacon({ x, y, visible }: BeaconProps) {
  if (!visible) return null;

  return (
    <div
      className={styles.beacon}
      style={{
        left: `${x}%`,
        top: `${y}%`,
      }}
    >
      <div className={styles.ring}></div>
      <div className={styles.innerRing}></div>
    </div>
  );
}

export default Beacon;